import React from "react";
import { CaptionsMenu } from "./settingsMenu/CaptionsMenu";
import { PlaybackRateMenu } from "./settingsMenu/PlaybackRateMenu";
import styles from "./SettingsMenu.css";

export const SettingsMenu = React.forwardRef((_, ref) => (
  <div ref={ref} className={styles.root}>
    <CaptionsMenu />
    <PlaybackRateMenu />
  </div>
));
